export const FORM_TEXT = {
  ADDRESS: 'form.address',
  CONTACT_NUMBER: 'form.contact_number',
  CONTINUE: 'form.continue',
  CURRENT_PASSWORD: 'form.current_password',
  DATE_OF_BIRTH: 'form.date_of_birth',
  EMAIL_ADDRESS: 'placeholder.email_address',
  EMAIL: 'form.email',
  FIRST_NAME: 'form.first_name',
  FORGOT_PASSWORD: 'placeholder.forgot_password',
  FULL_NAME: 'label.full_name',
  LAST_NAME: 'form.last_name',
  NEW_PASSWORD: 'form.new_password',
  NEW_USER: 'new_user',
  PASSWORD: 'placeholder.password',
  RETYPE_NEW_PASSWORD: 'form.retype_new_password',
  ROLE: 'form.role',
  SAVE: 'save',
  SIGNIN: 'form.signin',
  STATUS: 'status',
  SUBMIT: 'form.submit',
  TEMPOARY_PASSWORD: 'form.temporary_password',
  UPDATE_USER: 'form.update_user',
  UPDATE: 'form.update',
  UPLOAD: 'form.upload',
  USER_INFO: 'form.user_info',
}
